
<div *ngIf="card && !hasBeenReport" class="btn-track chip d-inline-block px-2 py-1">
    <div (click)="onReportClick()" class="d-flex flex-row align-items-center cursor-pointer">
        <div class="typo-chip px-1">{{ 'wap1_c_report_report' | translate }}</div>
        <img class="picto-small" src="../../../assets/images/231116/pictos/Report.svg" />
    </div>
</div>
<div *ngIf="hasBeenReport" class="typo-chip px-2 py-1">
    {{ 'wap1_c_report_thanks' | translate }}
</div>